import type { InstitutionType } from '@/api/gateway/legacy-api/resources/UniversityResource';
import type { StudyMaterialTypeId } from '@/utils/searchUtils';

export interface SearchFilters {
    university_id?: number;
    exclude_university_id?: number;
    institution_type?: InstitutionType;
    course_id?: number;
    language_id?: number;
    type_ids?: StudyMaterialTypeId[];
    has_ai_content?: boolean;
    min_academic_year?: number;
    max_academic_year?: number;
}

export enum TrackingContentType {
    DocumentsFlashcards = 'documents-flashcards',
    Courses = 'courses',
}
